import React from 'react';

import { IndicatorsContainer } from '../../containers/indicators';

export const Indicators: React.FC = () => <IndicatorsContainer />;
